<template>
  <BaseCenteredModal
    v-model:is-modal-open="localIsModalOpen"
    :title="modalTitle"
    size="medium"
    @close="handleClose"
  >
    <template #body>
      <div class="flex w-full flex-col gap-3">
        <div class="grid w-full grid-cols-1 gap-3 md:grid-cols-2">
          <div>
            <SelectPaymentStatuses
              v-model="payment.payment_status"
              :errors="errors.payment_status"
              edition-mode
              name="payment_status"
              required
            />
          </div>
          <div>
            <BaseShowEditPriceInput
              v-model="payment.amount"
              :label="$t('invoicing.amount')"
              name="amount"
              :errors="errors.amount"
              :disabled="payment.payment_mode === PaymentMode.CREDIT_NOTE"
              edition-mode
              required
            />
            <span v-if="amountErrors?.length" class="form-help text-red-600">
              {{ amountErrors }}
            </span>
          </div>
          <div v-if="payment_modes.length > 0" class="col-start-1">
            <SelectComponent
              v-model="payment.payment_mode_id"
              name="payment_mode_id"
              :label="$t('global.payment_mode')"
              :values="payment_modes"
              display-key="denomination_index"
              required
            />
          </div>
          <div class="col-start-1 flex flex-col">
            <SelectComponent
              v-if="payment.payment_mode_id || payment_modes.length === 0"
              v-model="payment.payment_mode"
              :values="paymentModes"
              :label="$t('attributes.payment_mode')"
              :required="true"
              name="payment_mode"
              :errors="errors.payment_mode"
              :edition-mode="true"
              :disabled="payment.payment_mode === PaymentMode.CREDIT_NOTE"
            />
          </div>
          <template
            v-if="
              payment.payment_mode === PaymentMode.CHECK ||
              payment.payment_mode === PaymentMode.LEVY ||
              payment.payment_mode === PaymentMode.CAUTION_CHECK
            "
          >
            <div>
              <BaseShowEditInput
                v-model="payment.check_number"
                :label="$t('attributes.check_number')"
                name="check_number"
                :errors="errors.check_number"
                :edition-mode="true"
              />
            </div>
          </template>
          <div
            v-if="payment_mode_error"
            class="col-start-2 -mt-3 text-xs text-red-600"
          >
            {{ $t('validation.payment_mode_id_required') }}
          </div>
          <div class="col-start-1">
            <BaseShowEditDatePickerv2
              v-model:date="payment.emission_date"
              :label="$t('attributes.date')"
              :errors="errors.emission_date"
              edition-mode
              required
            />
          </div>
          <div v-if="payment.payment_mode === 'CHE'">
            <BaseShowEditDatePickerv2
              v-model:date="payment.expected_cashing_date"
              :label="$t('attributes.expected_cashing_date')"
              :errors="errors.expected_cashing_date"
              :today-default="false"
              edition-mode
            />
          </div>
          <!--          <template-->
          <!--            v-if="-->
          <!--              payment.payment_mode === PaymentMode.CHECK ||-->
          <!--              payment.payment_mode === PaymentMode.LEVY ||-->
          <!--              payment.payment_mode === PaymentMode.CAUTION_CHECK-->
          <!--            "-->
          <!--          >-->
          <!--            <div-->
          <!--              v-if="payment.issuing_bank_resource && !editBank"-->
          <!--              class="col-start-1"-->
          <!--            >-->
          <!--              <BaseInput-->
          <!--                v-model="payment.issuing_bank_resource.name"-->
          <!--                :label="$t('attributes.bank_id')"-->
          <!--                :name="$t('attributes.bank_id')"-->
          <!--                disabled-->
          <!--              />-->
          <!--            </div>-->
          <!--            <div-->
          <!--              v-if="payment.issuing_bank_resource && !editBank"-->
          <!--              class="col-start-2"-->
          <!--            >-->
          <!--              <BaseButton title="Change" @click="toggleRadioEdit"/>-->
          <!--            </div>-->

          <!--            <div v-if="editBank || !payment.issuing_bank" class="col-start-1">-->
          <!--              <BaseShowEditRadio-->
          <!--                v-model="bankType"-->
          <!--                :label="$t('attributes.bank_id')"-->
          <!--                :options="bankCreation"-->
          <!--                :extra-id="eventIndex"-->
          <!--                :edition-mode="true"-->
          <!--                name=""-->
          <!--                @change="changeBankOptions"-->
          <!--              />-->
          <!--            </div>-->

          <!--            <div v-if="editBank || !payment.issuing_bank" class="col-start-1">-->
          <!--              <SelectComponent-->
          <!--                v-if="-->
          <!--                  (!payment.payment_mode_id ||-->
          <!--                    payment.payment_mode_id === 'custom') &&-->
          <!--                  bankType === 1-->
          <!--                "-->
          <!--                :key="bankType"-->
          <!--                v-model="payment.issuing_bank"-->
          <!--                :label="$t('attributes.bank_id')"-->
          <!--                name="issuing_bank"-->
          <!--                :edition-mode="true"-->
          <!--                :values="filteredBanks"-->
          <!--                :errors="errors?.c"-->
          <!--                :searchable="true"-->
          <!--              />-->
          <!--              <BaseShowEditInput-->
          <!--                v-if="-->
          <!--                  (!payment.payment_mode_id ||-->
          <!--                    payment.payment_mode_id === 'custom') &&-->
          <!--                  bankType === 2-->
          <!--                "-->
          <!--                :key="bankType"-->
          <!--                ref="new_issuing_bank"-->
          <!--                v-model="payment.new_issuing_bank"-->
          <!--                :label="$t('attributes.bank_name')"-->
          <!--                name="new_issuing_bank"-->
          <!--                :errors="errors.issuing_bank"-->
          <!--                :edition-mode="true"-->
          <!--              />-->

          <!--              <BaseShowEditInput-->
          <!--                v-if="-->
          <!--                  payment.payment_mode_id &&-->
          <!--                  payment.payment_mode_id !== 'custom'-->
          <!--                "-->
          <!--                :key="bankType"-->
          <!--                ref="single_use_issuing_bank"-->
          <!--                v-model="payment.single_use_issuing_bank"-->
          <!--                :label="$t('attributes.bank_name')"-->
          <!--                name="single_use_issuing_bank"-->
          <!--                :errors="errors.issuing_bank"-->
          <!--                :edition-mode="true"-->
          <!--              />-->
          <!--            </div>-->
          <!--            <div class="col-start-2">-->
          <!--              <p-->
          <!--                v-if="bankType === 2 && (editBank || !payment.issuing_bank)"-->
          <!--                :key="bankType"-->
          <!--                class="mt-3 font-medium leading-none text-red-600"-->
          <!--              >-->
          <!--                {{ $t('global.bank_available_in_selection_banks') }}-->
          <!--              </p>-->
          <!--              <p-->
          <!--                v-if="bankType === 3 && (editBank || !payment.issuing_bank)"-->
          <!--                :key="bankType"-->
          <!--                class="mt-3 font-medium leading-none text-red-600"-->
          <!--              >-->
          <!--                {{ $t('global.bank_unavailable_in_selection_banks') }}-->
          <!--              </p>-->
          <!--            </div>-->
          <!--            <div v-if="editBank && payment.issuing_bank && paymentId">-->
          <!--              <BaseButton title="Cancel changes" @click="toggleRadioEdit"/>-->
          <!--            </div>-->
          <!--          </template>-->

          <div class="col-start-1">
            <SelectComponent
              v-if="payment.payment_mode_id || payment_modes.length === 0"
              v-model="payment.bank_account_id"
              :label="$t('attributes.bank_account_id')"
              name="bank_account_id"
              :edition-mode="true"
              :values="bankAccounts"
              :errors="errors?.bank_account_id"
            />
          </div>
          <div>
            <SelectUser
              v-model="payment.recipient_id"
              :errors="errors?.recipient_id"
              :label="$t('attributes.received_by')"
              name="received_by"
              edition-mode
              required
            />
          </div>
          <div
            v-if="payment.payment_mode === PaymentMode.CHECK"
            class="col-start-1"
          >
            <BaseShowEditInput
              v-model="payment.origin_bank_account"
              :label="$t('attributes.origin_bank_account')"
              :edition-mode="true"
              name="origin_bank_account"
              :errors="errors.zip"
            />
          </div>
          <div
            class="relative col-span-2 mt-2 flex flex-col gap-2 rounded border border-gray-200 px-2 py-3"
          >
            <h3
              class="capitalize-first absolute -top-2 left-2 z-10 -mt-px bg-gray-50 text-xs font-medium text-gray-900"
            >
              {{ $t('attributes.issuer') }}
            </h3>
            <div
              v-if="
                modelType === 'invoice' &&
                payment.payment_mode !== PaymentMode.LEVY
              "
            >
              <RadioCardComponent
                v-model="payment.tier_payant"
                :options="[
                  {
                    value: 0,
                    label: placeHolderIssuer ?? ''
                  },
                  {
                    value: 1,
                    label: $t('global.third_payment')
                  }
                ]"
                size="medium"
              />
            </div>
            <div
              v-else-if="payment.payment_mode === PaymentMode.LEVY"
              class="text-medium rounded border-gray-300 bg-gray-100 px-2 py-5 text-gray-700"
            >
              {{ placeHolderDirectDebit }}
            </div>
            <template v-if="payment.tier_payant === 1">
              <div class="flex flex-col gap-2">
                <h3 class="-my-1 text-sm">{{ $t('attributes.payer_type') }}</h3>
                <div>
                  <RadioCardComponent
                    v-model="payment.payer_type"
                    :options="[
                      {
                        value: 'App\\Models\\Person',
                        label: $t('global.dossier_contacts')
                      },
                      {
                        value: 'App\\Models\\Contact',
                        label: $t('navigation.address_book_title_main')
                      },
                      {
                        value: 'other',
                        label: $t('attributes.OTHER')
                      }
                    ]"
                  />
                </div>

                <div class="grid-form">
                  <div
                    v-if="payment.payer_type === 'App\\Models\\Person'"
                    class="col-start-1"
                  >
                    <SelectComponent
                      v-model="payment.payer_id"
                      :label="$t('attributes.issuer_name')"
                      name="contact"
                      :values="dossier_contacts"
                      track-by="id"
                      display-key="full_name"
                      required
                    />
                  </div>
                  <div
                    v-if="payment.payer_type === 'App\\Models\\Contact'"
                    class="col-start-1"
                  >
                    <SelectComponent
                      v-model="payment.payer_id"
                      :label="$t('attributes.issuer_name')"
                      name="contact"
                      :values="contacts"
                      track-by="id"
                      display-key="full_name"
                      searchable
                      required
                    />
                  </div>
                  <div
                    v-if="payment.payer_type === 'other'"
                    class="col-start-1"
                  >
                    <BaseShowEditInput
                      v-model="payment.issuer_name"
                      :label="$t('attributes.issuer_name')"
                      :edition-mode="true"
                      name="issuer_name"
                      :errors="errors.zip"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>

          <div class="col-span-2 col-start-1">
            <BaseShowEditTextArea
              v-model="payment.comment"
              class="col-span-2"
              :label="$t('attributes.remarks')"
              :placeholder="$t('hint.remarks_example')"
              :errors="errors.remarks"
              :edition-mode="true"
              name="comment"
            />
          </div>
        </div>
        <template v-if="modelType === 'invoice' && model.reference !== null">
          <div>
            <h2 class="capitalize-first text-xl font-bold">
              {{ $t('enums.invoicing.docTypes.' + model.doc_type) }}
            </h2>
            <div class="grid w-full grid-cols-1 gap-3 md:grid-cols-2">
              <div class="col-start-1">
                <SelectInvoiceStatuses
                  v-model="payment.next_invoice_status"
                  :label="$t('attributes.next_invoice_status')"
                  :errors="errors?.next_invoice_status"
                  edition-mode
                  required
                />
                <span v-if="showWarningMessage" class="form-help text-red-600">
                  <FontAwesomeIcon :icon="['fal', 'triangle-exclamation']" />
                  {{ $t('global.can_update_invoice_status') }}
                </span>
              </div>
            </div>
          </div>
          <div
            v-if="
              model.dossier_id &&
              model.doc_role === 'ff' &&
              payment.next_invoice_status === 'PAI' &&
              model.dossier.status !== 'PAY'
            "
          >
            <div class="flex w-full flex-col">
              <h2
                class="capitalize-first text-xs font-medium"
                v-html="$t('global.change_dossier_status')"
              ></h2>
              <div class="col-start-1">
                <BaseShowEditRadio
                  v-model="change_status_dossier"
                  class="col-span-1"
                  :edition-mode="true"
                  size="extra-small"
                  name="change_status_dossier"
                  :options="[
                    { id: 1, name: $t('enums.yesNo.1') },
                    { id: 0, name: $t('enums.yesNo.0') }
                  ]"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
    <template #footer>
      <BaseButton
        :title="mainButtonTitle"
        :icon="mainButtonIcon"
        :display-loader="formSubmitting"
        :disabled="formSubmitting"
        color="primary"
        @click="submitForm"
      />
    </template>
  </BaseCenteredModal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { PaymentMode } from '@/assets/enums'
import BaseCenteredModal from '@c/addf-package/components/modal/BaseCenteredModal.vue'
import SelectPaymentStatuses from '@c/InitialStateFormComponent/Enums/SelectPaymentStatuses.vue'
import BaseShowEditDatePickerv2 from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDatePickerv2.vue'
import SelectUser from '@c/InitialStateFormComponent/SelectUser.vue'
import SelectInvoiceStatuses from '@c/InitialStateFormComponent/Enums/SelectInvoiceStatuses.vue'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import BaseShowEditTextArea from '@c/addf-package/components/BaseShowEditInput/BaseShowEditTextArea.vue'
import SelectPaymentTypes from '@c/InitialStateFormComponent/Enums/SelectPaymentTypes.vue'
import SelectPaymentOrigins from '@c/InitialStateFormComponent/Enums/SelectPaymentOrigins.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import BaseInput from '@c/addf-package/components/BaseInput/BaseInput.vue'
import BaseShowEditRadio from '@c/addf-package/components/BaseShowEditRadioGroup/BaseShowEditRadio.vue'
import BaseShowEditPriceInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditPriceInput.vue'
import BaseShowEditInput from '@c/addf-package/components/BaseShowEditInput/BaseShowEditInput.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import RadioCardComponent from '@c/BaseFormComponent/RadioCardComponent.vue'

export default {
  name: 'PaymentFormModal',
  components: {
    RadioCardComponent,
    FontAwesomeIcon,
    BaseShowEditInput,
    BaseShowEditPriceInput,
    BaseShowEditRadio,
    BaseInput,
    SelectComponent,
    BaseShowEditTextArea,
    BaseButton,
    SelectInvoiceStatuses,
    SelectUser,
    BaseShowEditDatePickerv2,
    SelectPaymentStatuses,
    BaseCenteredModal
  },
  props: {
    isModalOpen: {
      type: Boolean,
      required: true
    },
    paymentId: {
      type: [String, Number],
      required: false,
      default: null
    },
    modelType: {
      type: String,
      required: true,
      validator: (val) => ['invoice', 'dossier'].includes(val)
    },
    model: {
      type: Object,
      required: true
    },
    placeHolderIssuer: {
      type: String,
      required: true
    },
    placeHolderDirectDebit: {
      type: String,
      required: true
    },
    bankType: {
      type: [Number],
      required: false,
      default: 1
    },
    editBank: {
      type: [Number],
      required: false,
      default: 0
    }
  },
  emits: ['close', 'update:is-modal-open'],
  data() {
    return {
      formSubmitting: false,
      PaymentMode: PaymentMode,
      payment: {},
      payment_modes: [],
      paymentMode: null,
      payment_mode_error: null,
      bankCreation: [
        {
          id: 1,
          name: this.$t('global.existing')
        },
        {
          id: 2,
          name: this.$t('global.new_bank')
        }
        // {
        //   id: 3,
        //   name: this.$t('global.single_use')
        // }
      ],
      bankType: 1,
      amountErrors: null,
      editBank: this.paymentId ? 0 : 1,
      showWarningMessage: false,
      change_status_dossier: false,
      originalAmount: 0,
      dossier_contacts: []
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth',
      errors: 'auth/getErrors',
      initialMetadata: 'metadata/getInitialMetadata',
      invoice_doc_types: 'metadata/getInvoiceDocTypes',
      contacts: 'metadata/getContactsMetadata'
    }),
    authIsSuperAdminOrManager() {
      return (
        this.auth.roles.includes('super-admin') ||
        this.auth.roles.includes('manager')
      )
    },
    dossier() {
      if (this.model_type === 'invoice') return this.model.dossier
      return this.model
    },
    restToPay() {
      const restToPay = parseFloat(
        Number(
          parseFloat(this.model?.total_tvac ?? 0) -
            parseFloat(this.model?.total_paid ?? 0)
        ).toFixed(2)
      )
      const originalAmount = parseFloat(
        parseFloat(this.originalAmount).toFixed(2)
      )

      return restToPay + originalAmount
    },
    modalTitle() {
      return this.paymentId
        ? this.$t('attributes.payment')
        : this.$t('button.add_new_m', { var: this.$t('attributes.payment') })
    },
    mainButtonTitle() {
      return this.paymentId
        ? this.$t('button.edit_new_m', { var: this.$t('attributes.payment') })
        : this.$t('button.save_new_m', { var: this.$t('attributes.payment') })
    },
    mainButtonIcon() {
      return this.paymentId ? 'pen' : 'paper-plane'
    },
    localIsModalOpen: {
      get() {
        return this.isModalOpen
      },
      set(value) {
        console.log(value)
        this.$emit('update:is-modal-open', value)
      }
    },
    bankAccounts() {
      return this.initialMetadata.models.bankAccounts?.length > 0
        ? this.initialMetadata.models.bankAccounts
        : (this.model?.bank_accounts ?? [])
    },
    paymentModes() {
      if (this.paymentMode && this.paymentMode.id !== 'custom') {
        return this.initialMetadata.enums?.payment_modes
          ?.filter((mode) => this.paymentMode.payment_modes.includes(mode.id))
          ?.sort((a, b) => a.name.localeCompare(b.name))
      } else {
        return this.initialMetadata.enums?.payment_modes
          ?.filter((mode) => {
            if (!this.dossier && mode.id === 'LEV') {
              return false
            }
            return true
          })
          .sort((a, b) => a.name.localeCompare(b.name))
      }
    },
    filteredBanks() {
      const filteredBanks = this.initialMetadata?.models.banks.filter(
        (bank) => !bank?.single_use
      )

      const sortedBanks = filteredBanks.sort((bankA, bankB) => {
        const nameA = (bankA?.name || '').toLowerCase()
        const nameB = (bankB?.name || '').toLowerCase()
        return nameA.localeCompare(nameB)
      })
      return sortedBanks
    }
  },
  watch: {
    isModalOpen(newValue, oldValue) {
      if (newValue) {
        if (this.modelType === 'dossier') {
          this.processFetchPaymentDossierByIdAction({
            dossier_id: this.model.id,
            payment_id: this.paymentId
          }).then((response) => {
            this.payment = {
              ...response.payment,
              payment_type: 'CRE'
            }
            this.payment_modes = response.metadata?.payment_modes ?? []
            this.dossier_contacts = response.metadata?.dossier_contacts ?? this.model?.contacts ?? []
            if (
              this.authIsSuperAdminOrManager &&
              this.payment_modes.length > 0
            ) {
              this.payment_modes.push({
                id: 'custom',
                denomination_index: 'custom'
              })
              this.payment.payment_mode_id =
                this.payment.payment_mode_id ?? 'custom'
            }
          })
        } else {
          this.processFetchPaymentInvoiceByIdAction({
            invoice_id: this.model.id,
            payment_id: this.paymentId
          }).then((response) => {
            this.payment = {
              ...response.payment,
              payment_type: 'CRE'
            }
            if (this.modelType === 'invoice') {
              this.payment.next_invoice_status = this.model.status
              this.originalAmount = this.payment.amount
            }
            this.payment_modes = response.metadata.paymentModes ?? []
            this.dossier_contacts =
              this.modelType === 'invoice'
                ? (response.metadata.dossier_contacts ?? [])
                : this.model.contacts

            if (
              this.authIsSuperAdminOrManager &&
              this.payment_modes.length > 0
            ) {
              this.payment_modes.push({
                id: 'custom',
                denomination_index: 'custom'
              })
              this.payment.payment_mode_id =
                this.payment.payment_mode_id ?? 'custom'
            }
          })
        }
      }
    },
    'payment.payment_mode_id'(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.paymentMode = this.payment_modes?.find(
          (mode) => mode.id === newValue
        )
        if (!this.paymentMode) return
        this.payment.bank_account_id = this.paymentMode.bank_account_id ?? this.payment.bank_account_id
        this.payment.single_use_issuing_bank =
          this.paymentMode.bank_account?.bank ?? null
        if (this.paymentMode.payment_modes?.length === 1) {
          this.payment.payment_mode = this.paymentMode.payment_modes[0]
        }
      }
    }
  },
  methods: {
    ...mapActions({
      processFetchInvoiceByIdAction: 'invoicing/fetchInvoiceID',
      processFetchNewPaymentAction: 'invoicing/fetchNewPayment',
      processStoreNewPaymentAction: 'invoicing/storeNewPayment',
      processFetchPaymentInvoiceByIdAction: 'invoicing/fetchPaymentById',
      processFetchPaymentDossierByIdAction: 'dossier/fetchPaymentDossierById',
      processUpdatePaymentByIdAction: 'invoicing/updatePaymentById',
      processUpdateDossierPaymentByIdAction: 'dossier/updateDossierPaymentById',
      processFetchNewBankAction: 'invoicing/storeNewBank'
    }),
    submitForm() {
      if (this.amountErrors?.length) return
      if (this.payment_modes?.length > 0 && !this.payment.payment_mode_id) {
        this.payment_mode_error = true
        return
      }
      this.formSubmitting = true
      if (this.modelType === 'dossier') {
        this.processUpdateDossierPaymentByIdAction({
          dossier_id: this.model.id,
          payment_id: this.payment.id,
          payment: this.payment
        })
          .then((_response) => {
            this.$h.toastSuccess(this.$t('toasts.payment_updated'))
            this.localIsModalOpen = false
            this.formSubmitting = false
            this.payment_mode_error = false
          })
          .catch((_reason) => {
            this.formSubmitting = false
          })
      } else {
        this.processUpdatePaymentByIdAction({
          invoice_id: this.model.id,
          payment_id: this.payment.id,
          payment: this.payment,
          change_status_dossier: this.change_status_dossier
        })
          .then((_response) => {
            this.$h.toastSuccess(this.$t('toasts.payment_updated'))
            this.localIsModalOpen = false
            this.formSubmitting = false
            this.change_status_dossier = null
            this.payment_mode_error = false
          })
          .catch((_reason) => {
            this.formSubmitting = false
          })
      }
    },
    checkAmount(v) {
      if (v > this.restToPay) {
        this.amountErrors = this.$t('validation.amount_error', {
          amount: this.$h.formatCurrency(this.restToPay ?? 0)
        })
      } else {
        this.amountErrors = null
      }
    },
    handleClose() {
      this.showWarningMessage = false
      this.$emit('close')
    }
  }
}
</script>
